var map = {
	"./main/typeshed.ca.json": [
		2072,
		72
	],
	"./main/typeshed.de.json": [
		9766,
		766
	],
	"./main/typeshed.en.json": [
		4824,
		444
	],
	"./main/typeshed.es-es.json": [
		9544,
		164
	],
	"./main/typeshed.fr.json": [
		5680,
		680
	],
	"./main/typeshed.ja.json": [
		2544,
		544
	],
	"./main/typeshed.ko.json": [
		5914,
		914
	],
	"./main/typeshed.nl.json": [
		8924,
		924
	],
	"./main/typeshed.zh-cn.json": [
		9712,
		712
	],
	"./main/typeshed.zh-tw.json": [
		2928,
		928
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8396;
module.exports = webpackAsyncContext;